export default ({ request }) => ({
  ftyMaterialBatchListApi(data = {}) {
    return request({
      url: '/factory/fty/material/batch/list',
      method: 'post',
      data,
    })
  },
  ftyMaterialBatchDetailApi(data = {}) {
    return request({
      url: '/factory/fty/material/batch/detail',
      method: 'post',
      data,
    })
  },
  ftyMaterialBatchSaveApi(data = {}) {
    return request({
      url: '/factory/fty/material/batch/save',
      method: 'post',
      data,
    })
  },
  ftyMaterialBatchDelApi(data = {}) {
    return request({
      url: '/factory/fty/material/batch/del',
      method: 'post',
      data,
    })
  },
})
